import { lazy } from 'react'

export const PhoneHabitsVariant1 = lazy(() => import('./PhoneHabitsVariant1'))
export const PhoneHabitsVariant2 = lazy(() => import('./PhoneHabitsVariant2'))
